import React, { Component, ErrorInfo, ReactNode } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="page-content">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6}>
                <Card className="text-center mt-5">
                  <Card.Body className="p-5">
                    <i
                      className="ri-error-warning-line text-warning"
                      style={{ fontSize: "4rem" }}
                    ></i>
                    <h4 className="mt-3">Une erreur inattendue est survenue</h4>
                    <p className="text-muted mb-4">
                      L'application a rencontré un problème. Veuillez recharger
                      la page ou revenir à l'accueil.
                    </p>
                    <div className="d-flex gap-2 justify-content-center">
                      <Button
                        variant="primary"
                        onClick={() => window.location.reload()}
                      >
                        <i className="ri-refresh-line me-1"></i>
                        Recharger
                      </Button>
                      <Button variant="outline-secondary" onClick={this.handleReset}>
                        <i className="ri-home-4-line me-1"></i>
                        Accueil
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
